module.exports = __webpack_public_path__ + "static/media/beer.4c6c4fb3.svg";